import * as React from 'react';

import { Dive } from '../api';
import { fitBounds } from 'google-map-react/utils';

var MyDivePoint = require('../assets/img/map-point.png');
var SharedDivePoint = require('../assets/img/map-point-shared.png');

export const getMapProps = (dives: Array<Dive>) => {
    let north = 0;
    let south = 0;
    let west = 0;
    let east = 0;

    if (dives !== undefined) {
        dives.forEach(dive => {
            // tslint:disable-next-line:triple-equals
            if (dive.latitude == undefined || dive.longitude == undefined) {
                return;
            }

            const diveLatitude = Number(dive.latitude);
            const diveLongitude = Number(dive.longitude);

            if (!north) {
                north = diveLatitude;
            } else if (diveLatitude > north) {
                north = diveLatitude;
            }

            if (!south) {
                south = diveLatitude;
            } else if (diveLatitude < south) {
                south = diveLatitude;
            }

            if (!west) {
                west = diveLongitude;
            } else if (diveLongitude < west) {
                west = diveLongitude;
            }

            if (!east) {
                east = diveLongitude;
            } else if (diveLongitude > east) {
                east = diveLongitude;
            }

            return {
                lat: diveLatitude,
                lng: diveLongitude
            };
        });
    }

    if (!north || !west || !south || !east) {
        return false;
    }

    const nw = {
        lat: north + 0.01,
        lng: west - 0.01
    };

    const se = {
        lat: south - 0.01,
        lng: east + 0.01
    };

    const size = {
        width: 600,
        height: 300
    };

    return fitBounds({ nw, se }, size);
};

export interface IMapPointProps {
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    shared: boolean;
    // tslint:disable-next-line:no-any
    display?: any;
    // tslint:disable-next-line:no-any
    lat: any;
    // tslint:disable-next-line:no-any
    lng: any;
}

export default class MapPoint extends React.Component<IMapPointProps> {
    onClick(e: React.MouseEvent<HTMLDivElement>) {
        if (this.props.onClick !== undefined) {
            this.props.onClick(e);
        }
    }

    render() {
        return (
            <div
                className={
                    'mapsPoint' +
                    (this.props.onClick !== undefined ? ' clicked' : '') +
                    (this.props.shared ? ' shared' : '')
                }
                onClick={e => this.onClick(e)}
            >
                <img
                    src={this.props.shared ? SharedDivePoint : MyDivePoint}
                    alt=""
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MapPoint.tsx